import { toast } from 'react-hot-toast'

let errorCount = 0
let lastErrorTime = 0
const ERROR_THRESHOLD = 3
const ERROR_RESET_TIME = 10000 // 10 seconds

export const handleGlobalError = (error: any, context?: string) => {
  const now = Date.now()
  
  // Reset error count if enough time has passed
  if (now - lastErrorTime > ERROR_RESET_TIME) {
    errorCount = 0
  }
  
  errorCount++
  lastErrorTime = now
  
  console.error(`Global error ${errorCount}${context ? ` in ${context}` : ''}:`, error)
  
  // If too many errors, clear all toasts and show a single message
  if (errorCount >= ERROR_THRESHOLD) {
    toast.dismiss() // Clear all existing toasts
    toast.error('Multiple errors detected. Please refresh the page or contact support.', {
      duration: 8000,
      id: 'global-error'
    })
    return
  }
  
  // For individual errors, show them normally
  const errorMessage = error?.response?.data?.error || error?.message || 'An error occurred'
  toast.error(errorMessage, {
    duration: 5000,
    id: `error-${Date.now()}`
  })
}

export const resetErrorCount = () => {
  errorCount = 0
  lastErrorTime = 0
}
